"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleInvocationType = void 0;
var RuleInvocationType;
(function (RuleInvocationType) {
    /** Occurs when an existing instance is initialized. */
    RuleInvocationType[RuleInvocationType["InitExisting"] = 2] = "InitExisting";
    /** Occurs when a new instance is initialized. */
    RuleInvocationType[RuleInvocationType["InitNew"] = 4] = "InitNew";
    /** Occurs when a property value is retrieved. */
    RuleInvocationType[RuleInvocationType["PropertyGet"] = 8] = "PropertyGet";
    /** Occurs when a property value is changed. */
    RuleInvocationType[RuleInvocationType["PropertyChanged"] = 16] = "PropertyChanged";
})(RuleInvocationType = exports.RuleInvocationType || (exports.RuleInvocationType = {}));
